(() => {
  const root = document.querySelector('[data-sk-team]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';

  const teamHandle = root.dataset.team;
  const teamUrl = new URL(root.dataset.teamUrl, location.href);
  const tabs = [...root.querySelectorAll('.sk-team-categories a[data-category-handle]')];
  const preview = new URL(location.href).searchParams.get('preview_theme_id');
  const resultParam = key => key === 'sort_by' || key === 'page' || key.startsWith('filter.');
  let controller;

  const preservePreview = element => {
    if (!preview) return;
    element.querySelectorAll('a[href]').forEach(link => {
      if (link.getAttribute('href').startsWith('#')) return;
      const url = new URL(link.href, location.href);
      if (url.origin !== location.origin) return;
      url.searchParams.set('preview_theme_id', preview);
      link.href = url.href;
    });
  };

  const tabFor = handle => tabs.find(tab => tab.dataset.categoryHandle === handle);
  const selectedHandle = () => {
    const requested = new URL(location.href).searchParams.get('category');
    return tabFor(requested)?.dataset.categoryHandle || teamHandle;
  };
  const sourceFromLocation = handle => {
    const url = new URL(tabFor(handle)?.href || teamUrl, location.href);
    for (const [key, value] of new URL(location.href).searchParams) {
      if (resultParam(key)) url.searchParams.append(key, value);
    }
    if (preview) url.searchParams.set('preview_theme_id', preview);
    return url;
  };
  const visibleUrl = (source, handle) => {
    const url = new URL(location.href);
    for (const key of [...url.searchParams.keys()]) {
      if (key === 'category' || resultParam(key)) url.searchParams.delete(key);
    }
    if (handle !== teamHandle) url.searchParams.set('category', handle);
    for (const [key, value] of source.searchParams) {
      if (resultParam(key)) url.searchParams.append(key, value);
    }
    url.hash = 'SkTeamProducts';
    return url;
  };

  const render = async (source, handle, { push = true, scroll = true } = {}) => {
    controller?.abort();
    controller = new AbortController();
    const signal = controller.signal;
    const current = root.querySelector('[data-sk-team-results]');
    current?.setAttribute('aria-busy', 'true');
    const request = new URL(source);
    request.hash = '';
    request.searchParams.set('section_id', 'sk-team-results');
    try {
      const response = await fetch(request, { signal });
      if (!response.ok) throw new Error(`Collection response ${response.status}`);
      const documentResult = new DOMParser().parseFromString(await response.text(), 'text/html');
      const next = documentResult.querySelector('[data-sk-team-results]');
      if (!next || next.dataset.collectionHandle !== handle) throw new Error('Collection results unavailable');
      preservePreview(next);
      root.querySelector('[data-sk-team-results]')?.replaceWith(next);
      tabs.forEach(tab => {
        if (tab.dataset.categoryHandle === handle) tab.setAttribute('aria-current', 'page');
        else tab.removeAttribute('aria-current');
      });
      root.querySelector('.sk-team-categories__more')?.removeAttribute('open');
      if (push) history.pushState({ teamCategory: handle }, '', visibleUrl(source, handle));
      if (scroll) next.scrollIntoView({ block: 'start', behavior: 'auto' });
    } catch (error) {
      if (!signal.aborted) location.assign(source.href);
    } finally {
      if (!signal.aborted) root.querySelector('[data-sk-team-results]')?.removeAttribute('aria-busy');
    }
  };

  root.addEventListener('click', event => {
    if (!matchMedia('(max-width:749px)').matches) return;
    const link = event.target.closest('a[href]');
    if (!link || !root.contains(link)) return;
    const tab = link.closest('.sk-team-categories') ? link : null;
    if (tab?.dataset.categoryHandle) {
      event.preventDefault();
      const source = new URL(tab.href, location.href);
      for (const [key, value] of new URL(location.href).searchParams) {
        if (key === 'sort_by' || key.startsWith('filter.')) source.searchParams.append(key, value);
      }
      render(source, tab.dataset.categoryHandle);
      return;
    }
    if (!link.closest('[data-sk-team-results]')) return;
    if (!link.matches('.sk-team-pagination a, .sk-team-active-filters a, .sk-team-filter-actions a, .sk-team-empty a')) return;
    event.preventDefault();
    const handle = root.querySelector('[data-sk-team-results]')?.dataset.collectionHandle || teamHandle;
    render(new URL(link.href, location.href), handle);
  });

  root.addEventListener('change', event => {
    if (event.target.matches('[data-sk-team-sort]')) event.target.form?.requestSubmit();
  });
  root.addEventListener('submit', event => {
    if (!matchMedia('(max-width:749px)').matches) return;
    const form = event.target;
    if (!form.matches('[data-sk-team-filter-form]')) return;
    event.preventDefault();
    const url = new URL(form.action, location.href);
    const params = new URLSearchParams(new FormData(form));
    for (const [key, value] of [...params]) {
      if (value === '') params.delete(key);
    }
    if (preview) params.set('preview_theme_id', preview);
    url.search = params.toString();
    const handle = root.querySelector('[data-sk-team-results]')?.dataset.collectionHandle || teamHandle;
    render(url, handle);
  });

  window.addEventListener('popstate', () => {
    const handle = selectedHandle();
    render(sourceFromLocation(handle), handle, { push: false, scroll: false });
  });

  root.querySelector('[data-sk-team-bag]')?.addEventListener('click', event => {
    const drawer = document.querySelector('theme-drawer#cart-drawer');
    if (drawer?.open) {
      event.preventDefault();
      drawer.open();
    }
  });

  preservePreview(root);
  const initialHandle = selectedHandle();
  if (initialHandle !== teamHandle) {
    render(sourceFromLocation(initialHandle), initialHandle, { push: false, scroll: false });
  }
})();
